export default __webpack_public_path__ + "static/media/sn0.0d1eaa5b.jpg";